<div class="forgot-password-page">
  <div class="forgot-password-container">
    <div class="image-section">
      <img src="/assets/BuddieBeatz.png" alt="Company Logo" />
    </div>
    <div class="form-section">
      <h2>Forgot Password</h2>
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email">Email</label>
          <div class="input-group">
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="Email"
              [ngClass]="{
                'error-border': forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched
              }"
              required
            />
            <span class="icon"><i class="fa fa-envelope"></i></span>
          </div>
          <div
            class="error-message"
            *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched"
          >
            Email is required.
          </div>
        </div>
        <button type="submit" [disabled]="forgotPasswordForm.invalid">Submit</button>
      </form>
    </div>
  </div>
</div>
